<template>
  <div class='table-responsive text-nowrap'>
    <a-table :columns='columns' :row-key='data.id' :data-source='data' :pagination="false" :loading='loading'>
      <template #address='{ text }'>
        <a-row>
          <a-col span="6" class="text-right font-weight-bold small pr-2">
            Calle:
          </a-col>
          <a-col span="18" class="text-left small pl-2">
            {{ text.street }}
          </a-col>
        </a-row>
        <a-row>
          <a-col span="6" class="text-right font-weight-bold small pr-2">
            Lugar:
          </a-col>
          <a-col span="18" class="text-left small pl-2">
            {{ text.place }}
          </a-col>
        </a-row>
        <a-row>
          <a-col span="6" class="text-right font-weight-bold small pr-2">
            Colonia:
          </a-col>
          <a-col span="18" class="text-left small pl-2">
            {{ text.district }}
          </a-col>
        </a-row>
        <a-row>
          <a-col span="6" class="text-right font-weight-bold small pr-2">
            Delegación o municipio:
          </a-col>
          <a-col span="18" class="text-left small pl-2">
            {{ text.municipality }}
          </a-col>
        </a-row>
        <a-row>
          <a-col span="6" class="text-right font-weight-bold small pr-2">
            Estado:
          </a-col>
          <a-col span="18" class="text-left small pl-2">
            {{ text.state }}
          </a-col>
        </a-row>
        <a-row>
          <a-col span="6" class="text-right font-weight-bold small pr-2">
            Código postal:
          </a-col>
          <a-col span="18" class="text-left small pl-2">
            {{ text.zipCode }}
          </a-col>
        </a-row>
      </template>
      <template #detail='{ text }'>
        <a-row>
          <a-col span="12" class="text-right font-weight-bold small pr-2">
            RFC:
          </a-col>
          <a-col span="12" class="text-left small pl-2">
            {{ text.rfc }}
          </a-col>
        </a-row>
        <a-row>
          <a-col span="12" class="text-right font-weight-bold small pr-2">
            CANACINTRA:
          </a-col>
          <a-col span="12" class="text-left small pl-2">
            {{ text.canacintraRegistration }}
          </a-col>
        </a-row>
        <a-row>
          <a-col span="12" class="text-right font-weight-bold small pr-2">
            CMIC:
          </a-col>
          <a-col span="12" class="text-left small pl-2">
            {{ text.cmic }}
          </a-col>
        </a-row>
      </template>
      <template #action='{ text }'>
        <a-button @click="$emit('openModal', text)" class='btn btn-sm btn-light mr-2'>
          <i class='fe fe-edit mr-2' />
          Editar
        </a-button>
        <a-button @click="$emit('softDelete', text)" class='btn btn-sm btn-outline-danger mr-2'>
          <i class='fe fe-trash mr-2' />
          Eliminar
        </a-button>
      </template>
    </a-table>
  </div>
</template>

<script>

const columns = [
  {
    title: 'Nombre de Razón Social',
    dataIndex: 'name',
    class: 'text-center',
  },
  {
    title: 'Domicilio',
    slots: { customRender: 'address' },
    class: 'text-center',
  },
  {
    title: 'Detalle',
    slots: { customRender: 'detail' },
    class: 'text-center',
  },
  {
    title: 'Acciones',
    slots: { customRender: 'action' },
    class: 'text-center',
  },
]

export default {
  name: 'BusinessSettingTable',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Object],
      require: true,
      defaultValue: {},
    },
    // eslint-disable-next-line vue/require-default-prop
    loading: {
      type: [Boolean],
      require: true,
      defaultValue: false,
    },
  },
  emits: [
    'openModal', 'softDelete',
  ],
  setup() {
    return {
      columns,
    }
  },
}
</script>

<style scoped></style>
